import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import { environment } from '../../../environments/environment';
import { Alert } from '../../Models/alert';
import { ApiService } from '../../core/services/api.service';
import { AuthorizationEnum } from '../../enums/authorization-enum';
import { UserDto } from '../../dtos/user-dto';

const API_URL = environment.apiUrl;

export interface Section {
  name: string;
  updated: Date;
}


@Component({
    selector: 'notification-badge',
    templateUrl: './notification-badge.component.html',
  styleUrls: ['./notification-badge.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NotificationBadgeComponent implements OnInit{

  hubConnection: HubConnection;

  alerts: Alert[] = [];
  public authorizationType: AuthorizationEnum = 100;
  public authorizationEnum: AuthorizationEnum;

  folders: Section[] = [
    {
      name: 'Photos',
      updated: new Date('1/1/16'),
    }
  ];
  constructor(private apiService: ApiService) {
    
  }

  ngOnInit(): void {
    let userStorage = localStorage.getItem('currentUser');
    if (userStorage) {
      let user: UserDto = JSON.parse(userStorage);
      if (user) {
        this.authorizationType = user.auth;
      }
    }
    this.getNotifications();
    this.startConnection();
  }

  startConnection() {
    this.hubConnection = new HubConnectionBuilder().withUrl(API_URL + 'notification').build();
    this.hubConnection
      .start()
      .then(() => {
        console.log('Connection started!')
        
        this.hubConnection.invoke('JoinRoom', this.authorizationType.toString());
      })
      .catch(err => console.log('Error while establishing connection :('));

      this.hubConnection
    this.hubConnection.on('BroadcastMessage', (alert: Alert) => {
      //if (alerts.length == 1) {
       // if (this.authorizationType == 0 || this.authorizationType == alerts[0].authorization) {
          this.alerts.push(alert);
       // }
     // } else {
       // if (alerts.length > 1) {
         // alerts.forEach(item => {
          //  if (this.authorizationType == item.authorization) {
            //  this.alerts.push(item);
           // }
          //});
        //}
      //}
    });
  }

  markAllAsRead() {
    this.alerts.forEach(item => {
      item.read = true;
    });
    this.apiService.put('api/alert/ReadNotification', this.alerts).subscribe(response => {
      if (response) {
        this.alerts = [];
      }
    });
  }

  getNotifications() {
    let url: string = '';
    if (this.authorizationType == AuthorizationEnum.HOST_CLIENT)
      url = 'api/alert/GetAlertsClient';
    else
      url = 'api/alert/GetByAuth'
    this.apiService.get(url).subscribe(response => {
      if (response) {
        this.alerts = response.data;
        console.log(this.alerts);
      }
    });
  }
}
